<div class="bottom-sheet-container" *ngIf="isOpen">
  <div class="bottom-sheet">
    <div class="header">
      <h1>
        {{data.title}}
      </h1>
      <div class="close-button-wrapper" (click)="close()">
        <svg-icon [svgStyle]="{'width.px': 18, 'height.px': 18}" src="/assets/icons/x.svg"></svg-icon>
      </div>
    </div>
    <div class="content">
      <ng-container *ngTemplateOutlet="template"></ng-container>
    </div>
  </div>
</div>
